import LeadsHomePage from "./LeadsHomePage";

export default LeadsHomePage;
